import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M7.5 0h-5A1.5 1.5 0 0 0 1 1.5v8a.5.5 0 0 0 .791.407l3.064-2.189a.25.25 0 0 1 .29 0l3.064 2.189A.5.5 0 0 0 9 9.5v-8A1.5 1.5 0 0 0 7.5 0"
    }, null, -1)
  ]));
}
const interfaceBookmark = { render };
export {
  interfaceBookmark as default,
  render
};
//# sourceMappingURL=interface-bookmark.svg.js.map
